/* Wiping Hub industry hover stability fix, preview only */
(function(){
  function setup(){
    document.querySelectorAll('.navmenu-id-shop-by-industry').forEach(function(item){
      if(item.dataset.whHoverReady==='1') return;
      var details=item.querySelector(':scope > details');
      var panel=item.querySelector('.wh-industry-mega');
      if(!details||!panel) return;
      item.dataset.whHoverReady='1';
      var closeTimer;
      var hovered=false;
      function cancel(){window.clearTimeout(closeTimer)}
      function open(){
        if(!window.matchMedia('(min-width:1024px) and (hover:hover)').matches)return;
        hovered=true;cancel();
        if(!details.open)details.open=true;
        item.classList.add('wh-industry-open');
      }
      function close(){
        hovered=false;cancel();
        closeTimer=window.setTimeout(function(){
          if(hovered||item.matches(':focus-within'))return;
          item.classList.remove('wh-industry-open');
          details.open=false;
        },230);
      }
      item.addEventListener('pointerenter',function(e){if(e.pointerType==='mouse')open()});
      item.addEventListener('pointerleave',function(e){if(e.pointerType==='mouse')close()});
      panel.addEventListener('pointerenter',function(e){if(e.pointerType==='mouse')open()});
      panel.addEventListener('pointerleave',function(e){if(e.pointerType==='mouse')close()});
      item.addEventListener('focusin',function(){cancel();item.classList.add('wh-industry-open');details.open=true});
      item.addEventListener('focusout',function(){closeTimer=window.setTimeout(function(){if(!item.matches(':focus-within')){item.classList.remove('wh-industry-open');details.open=false}},230)});
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&item.classList.contains('wh-industry-open')){item.classList.remove('wh-industry-open');details.open=false;item.querySelector('summary')?.focus()}});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
})();